import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import "./ConsultantDashboard.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { ILogin } from "../../models/Login";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { JVSunEditor } from "../../shared/JVSuneditor";

export const ConsultantProjectDetails = ({ project }: { project: IPurchaseOrder }) => {
  const [jobModel, setJobModel] = useState(false);
  const [jd, setJd] = useState<any>([]);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

  const onHide = () => {
    setJobModel(false);
  };
  function handleJobDescription() {
    setJobModel(true);
  };

  useEffect(() => {
    if (project?.pO_ID && jobModel === true) {
      let jobDescription = loginObj.jDs?.filter(e => e.req_ID === project?.req_ID)[0]?.req_JobDescription || "";
      setJd(jobDescription);
    }
  }, [project, jobModel]);

  return (
    <>
      <Card title="Project Details" style={{ marginBottom: "20px", backgroundColor: "#0093E9", backgroundImage: "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)", borderRadius: "10px", padding: "20px", color: "#F0F0F0", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", }}>
        <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", }}>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>End Client:</strong>{" "}
            <span>{project?.project_Client_Name}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Location:</strong>{" "}
            <span>{`${project?.city_Name || ""}, ${project?.state_Name || ""}`}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Role:</strong>{" "}
            <span>{project?.req_Job_Title}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Start Date:</strong>{" "}
            <span>{(project?.project_Start_Date1 || "").split('/')[1]}/{(project?.project_Start_Date1 || "").split('/')[0]}/{(project?.project_Start_Date1 || "").split('/')[2]}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Duration:</strong>{" "}
            <span>{project?.req_Duration} </span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Expected End Date:</strong>{" "}
            <span>{(project?.project_End_Date1 || "").split('/')[1]}/{(project?.project_End_Date1 || "").split('/')[0]}/{(project?.project_End_Date1 || "").split('/')[2]}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#FFD700", cursor: "pointer", textDecoration: "underline", }} onClick={handleJobDescription}>
            Show Job Description
          </p>
        </div>
      </Card>

      <Dialog visible={jobModel} style={{ width: "65vw" }} header="Job Description" modal className="p-fluid" onHide={onHide}>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "black" }} onClick={handleJobDescription}>
          {<JVSunEditor value={`<p><b>Job Description -</b> \n${jd}</p>`} />}
        </p>
      </Dialog>
    </>
  );
};
